import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const RewardsSelectRecipient = ({ onNext = () => {}, onBack = () => {}, inputs, canGoNext }) => {
  const { t } = useTranslation(['rewards-gift', 'common'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view select-recipient">
        <div className="rewards-modal-input-row">
          {inputs.first && (
            <div className="input-container">
              <div className="input-label">{inputs.first.label}</div>
              {inputs.first.render()}
            </div>
          )}
        </div>
        <div className="rewards-modal-input-row" style={{ display: 'flex', gap: 8 }}>
          {inputs.second && (
            <div className="input-container" style={{ width: '100%' }}>
              <div className={`input-label ${inputs.second.disabled ? 'disabled' : ''}`}>
                {inputs.second.label}
              </div>
              {inputs.second.render()}
            </div>
          )}
          {inputs.third && (
            <div className="input-container" style={{ width: '50%' }}>
              <div className={`input-label ${inputs.third.disabled ? 'disabled' : ''}`}>
                {inputs.third.label}
              </div>
              {inputs.third.render()}
            </div>
          )}
        </div>
        {inputs.fourth && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className={`input-label ${inputs.fourth.disabled ? 'disabled' : ''}`}>
                {inputs.fourth.label}
              </div>
              {inputs.fourth.render()}
            </div>
          </div>
        )}
        {inputs.fifth && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className={`input-label ${inputs.fifth.disabled ? 'disabled' : ''}`}>
                {inputs.fifth.label}
              </div>
              {inputs.fifth.render()}
            </div>
          </div>
        )}
        {inputs.sixth && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className={`input-label ${inputs.sixth.disabled ? 'disabled' : ''}`}>
                {inputs.sixth.label}
              </div>
              {inputs.sixth.render()}
            </div>
          </div>
        )}
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary" disabled={!canGoNext} onClick={onNext}>
          {t('rewards-gift:sendGiftForm.selectGiftButton')}
        </button>
      </div>
    </div>
  )
}

RewardsSelectRecipient.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  inputs: PropTypes.object,
  canGoNext: PropTypes.bool,
}

export default RewardsSelectRecipient
